import * as React from 'react';
import { connect } from 'react-redux';
import { INewbuildingRecommendations } from '../../models/newbuilding_recommendations';
import { IStore } from '../../models/store';
import { getNewbuildingRecommendationsData } from '../../redux/modules/mainpage';
import { RecommendedItem } from './recomended_item';
import { RecommendationsPointer } from '../../../shared/components/RecommendationsPointer';
import { openRecommendedNewbuilding, showRecommendedNewbuilding } from './track';
import { isElementVisible } from '../../helpers/is_element_visible';

const styles = require('./index.css');

interface IOwnProps {
  experimentGroup: number | null;
}

interface IMapStateToProps {
  newbuilding_recommendations: INewbuildingRecommendations[];
}

interface IDispatchToProps {
  initRecommendations(): void;
}

type TProps = IOwnProps & IMapStateToProps & IDispatchToProps;

interface IState {
  isPointerVisible: boolean;
}

export class Recommandations extends React.Component<TProps, IState> {
  private container = React.createRef<HTMLDivElement>();

  public state: IState = {
    isPointerVisible: false,
  };

  public componentDidMount() {
    this.props.initRecommendations();
  }

  public componentDidUpdate(prevProps: TProps) {
    if (!prevProps.newbuilding_recommendations.length
      && this.props.newbuilding_recommendations.length > 0
      && !isElementVisible(this.container.current)
    ) {
      this.setState({ isPointerVisible: true }, () => {
        window.addEventListener('scroll', this.scrollHandler);
      });
    }
  }

  public scrollHandler = () => {
    if (isElementVisible(this.container.current)) {
      window.removeEventListener('scroll', this.scrollHandler);
      this.setState({ isPointerVisible: false });
    }
  }

  private renderItem = (newbuilding: INewbuildingRecommendations, index: number) => {
    const {fullAddress, underground, fullUrl, image, priceDisplay, name} = newbuilding;

    return <RecommendedItem
      key={newbuilding.id}
      address={fullAddress}
      metro={underground}
      url={fullUrl}
      priceDisplay={priceDisplay}
      thumbnailUrl={image ? image.thumbnailUrl : undefined}
      name={name}
      onClick={() => openRecommendedNewbuilding(newbuilding, index)}
    />;
  }

  private renderPointer = (): JSX.Element | null => {
    const { experimentGroup } = this.props;

    return (
      <RecommendationsPointer type={experimentGroup === 3 ? 'arrow' : 'finger'}
        visible={this.state.isPointerVisible}
        isAnimated={experimentGroup !== 2}
      />
    );
  }

  public render() {
    const { newbuilding_recommendations } = this.props;

    if (!newbuilding_recommendations.length) {
      return null;
    }

    showRecommendedNewbuilding(newbuilding_recommendations);

    return (
      <div className="cg-container-fluid-xs" ref={this.container}>
        <h2 className={styles['title']}>Рекомендованные ЖК{this.renderPointer()}</h2>
        <div className={styles['item-wrapper']}>
          {newbuilding_recommendations.map(this.renderItem)}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
  newbuilding_recommendations: state.mainpage.newbuilding_recommendations,
});

const mapDispatchToProps = {
  initRecommendations: getNewbuildingRecommendationsData,
};

export const RecommendedContainer =
  connect<IMapStateToProps, IDispatchToProps>(mapStateToProps, mapDispatchToProps)(Recommandations);
